import OrganDialog from "@/components/organDialog";

export let mixinOrgan = {
  data() {
    return {
      selectNode: '',
      isList: false, //判断是不是列表使用
      selectNodeForQuery: '',//列表中存在两个组织机构选择情况
      isList1: true,
      levell: [1, 2],
      organLabel: '',
      selectName: '',
      selectNodes: [], // 多选模式-表单区选中节点
      selectNodesForQuery: [], // 多选模式-查询区选中节点
      checkLevel: 3, // 多选模式下限制可选级别，默认3=班级
    };
  },
  components: {
    OrganDialog
  },
  watch: {
    '$store.state.userInfo.defaultStructure': {
      handler: function (val) {
        if (val) {
          this.selectNodeForQuery = {
            id: val.id,
            level: val.level,
            name: val.name,
            structure_ids: val.structure_ids,
            structure_names: val.structure_text2
          }
          this.handleQuery()
        }
      },
      deep: false,
    },
  },
  created() {
    let userInfo = this.$store.state.userInfo
    if (userInfo.defaultStructure) {
      this.selectNodeForQuery = {
        id: userInfo.defaultStructure.id,
        level: userInfo.defaultStructure.level,
        name: userInfo.defaultStructure.name,
        structure_ids: userInfo.defaultStructure.structure_ids,
        structure_names: userInfo.defaultStructure.structure_text2
      }
    }
  },
  mounted() {
  },
  methods: {
    dialogOpen() {
      this.$refs.organDia.orgDialogVisible = true
    },
    dialogOpen1() {
      this.$refs.organDia1.orgDialogVisible = true
    },
    getSelect(node) {
      console.log(node)
      this.selectNode = node
    },
    getSelect1(node) {
      console.log(node)
      this.selectNodeForQuery = node
    },
    handleOrganQuery() {
      this.getOrganList()
      this.$refs.organDia.orgDialogVisible = false
    },
    handleOrganQuery1() {
      this.handleQuery()
      this.$refs.organDia1.orgDialogVisible = false
    },
    handeleClear() {
      this.selectNode = ''
      this.$refs.organDia.selectedNode = ''
      this.getOrganList()
    },
    handleOrganMultipleQueryNeed({
      key = 'bj',//指定的组织结构
      formKey = "ruleForm",
      needKey = 'class_name'
    } = {}) {
      if(this.selectNode&&this.selectNode.length){
        this[formKey][key] = this.selectNode.map(item=>item[needKey]).join(',')
      }else{
        this[formKey][key] = '';
      }
      this.$refs.organDia.orgDialogVisible = false
    },
    
    handleOrganQueryNeed({
      needKey = 'bj',//指定的组织结构
      level = 3,
      formKey = "ruleForm",
    } = {}) {
      if (this.selectNode.level == level) {
        this[formKey][needKey] = this.selectNode.name
      }
      if (!this.selectNode.name) {
        this[formKey][needKey] = '';
      }
      this.$refs.organDia.orgDialogVisible = false
    },
    handleOrganQueryNew(config) {
      this.beforeGetOrgan(config)
      this.$refs.organDia.orgDialogVisible = false
    },
    beforeGetOrgan({
      limit = true,
      dep = 'structure_1',
      major = 'major',
      formKey = "ruleForm",
      needId = { val: false }
    } = {}) {//是否limit=true限制系部专业，limit=false不限制系部专业必填,needId需要组织结构id
      if (this.selectNode.level == 2 || (!limit && this.selectNode.level == 1)) {
        this.selectName = this.selectNode.structure_names;
        const strArr = this.selectNode.structure_names.split('-');
        this[formKey][dep] = strArr[0];
        this[formKey][major] = strArr[1] ? strArr[1] : '';
        if (needId.val) {
          const sidArr = this.selectNode.structure_ids.split(',');
          this[formKey][dep + '_id'] = sidArr[0];
          if (this.selectNode.level == 2) {
            this[formKey][major + '_id'] = this.selectNode.structure_ids;
          }
        }
      }
      if (!this.selectName) {
        this[formKey][dep] = '';
        this[formKey][major] = '';
      }
    },
    getOrganListLevel3() {
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class_name = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class_name = '';
      }
    },
    beforeQuery() {
      if (this.selectNodeForQuery && this.selectNodeForQuery.structure_names) {
        this.organLabel = this.selectNodeForQuery.structure_names
        let strArr = this.organLabel.split('-');
        this.formInline.structure_1 = strArr[0] ? strArr[0] : '';
        this.formInline.major = strArr[1] ? strArr[1] : '';
      } else {
        this.organLabel = this.selectNodeForQuery.name ? this.selectNodeForQuery.name : '';
        this.formInline.structure_1 = '';
      }
    },
    beforeQuery1() {
      if (this.selectNodeForQuery && this.selectNodeForQuery.structure_names) {
        this.organLabel = this.selectNodeForQuery.structure_names;
        let strArr = this.organLabel.split('-');
        this.formInline.structure_1 = strArr[0] ? strArr[0] : '';
        this.formInline.structure_2 = strArr[1] ? strArr[1] : '';
      } else {
        this.organLabel = this.selectNodeForQuery.name ? this.selectNodeForQuery.name : '';
        this.formInline.structure_1 = '';
        this.formInline.structure_2 = '';
      }
    },

    beforeQueryByKey(dep, major, cls, formK = "formInline") {
      if (this.selectNodeForQuery && this.selectNodeForQuery.structure_names) {
        this.organLabel = this.selectNodeForQuery.structure_names;
        let strArr = this.organLabel.split('-');
        this[formK][dep] = strArr[0] ? strArr[0] : '';
        this[formK][major] = strArr[1] ? strArr[1] : '';
        if (cls && strArr.length > 2) {
          this[formK][cls] = strArr[2] ? strArr[2] : '';
        }

      } else {
        this.organLabel = this.selectNodeForQuery.name ? this.selectNodeForQuery.name : '';
        this[formK][dep] = '';
        this[formK][major] = '';
        if (cls) {
          this[formK][cls] = '';
        }
      }
    },
    beforeQueryByKeyNew({
      dep = 'structure_1',
      major = 'major',
      cls = 'class_name',
      formK = "formInline",
      needId = false } = {}) {
      if (this.selectNodeForQuery && this.selectNodeForQuery.structure_names) {
        // this.organLabel = this.selectNodeForQuery.structure_names;
        let organs = []
        let strArr = this.selectNodeForQuery.structure_names.split('-');
        this[formK][dep] = strArr[0] ? strArr[0] : '';
        organs.push(this[formK][dep])

        if (strArr.length >= 2 && this.levell.includes(2)) {
          this[formK][major] = strArr[1] ? strArr[1] : '';
          organs.push(this[formK][major])
        } else {
          this[formK][major] = ''
        }
        if (cls && strArr.length >= 3 && this.levell.includes(3)) {
          this[formK][cls] = strArr[2] ? strArr[2] : '';
          organs.push(this[formK][cls])
        } else {
          this[formK][cls] = ''
        }
        this.organLabel = organs.join('-')
        if (needId) {
          const sidArr = this.selectNodeForQuery.structure_ids.split(',');
          this[formK][dep] = sidArr[0];
          if (this.selectNodeForQuery.level >= 2 && this.levell.includes(2)) {
            this[formK][major] = sidArr[1];
          } else {
            this[formK][major] = '';
          }

          if (this.selectNodeForQuery.level == 3 && this.levell.includes(3)) {
            this[formK][cls] = sidArr[2];
          } else {
            this[formK][cls] = '';
          }
        }
      } else {
        this.organLabel = this.selectNodeForQuery.name ? this.selectNodeForQuery.name : '';
        this[formK][dep] = '';
        this[formK][major] = '';
        if (cls) {
          this[formK][cls] = '';
        }
      }
    },
    handeleClear1() {
      this.selectNodeForQuery = ''
      this.$refs.organDia1.selectedNode = ''
      // this.handleQuery()
    },
   
  }
};
